<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/institutionaldocs/edit">{{lang.LBL_ADD_REQUEST}}</router-link></li>
        <li><router-link to="/modules/institutionaldocs">{{lang.LBL_VIEW_REQUEST}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/InstitutionalDocs/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
}
</script>
